var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.1021,
    r: 10,
    fill: "#35475D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1692 9.77284C11.5958 9.77284 12.7524 8.36809 12.7524 6.63522C12.7524 4.90231 12.3727 3.49756 10.1692 3.49756C7.96574 3.49756 7.58594 4.90231 7.58594 6.63522C7.58594 8.36809 8.74254 9.77284 10.1692 9.77284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 14.6458C15.0483 14.6169 15.0473 14.4451 15.0469 14.6458V14.6458Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 14.4365C14.9939 11.4178 14.5997 10.5577 11.5828 10.0132C11.5828 10.0132 11.1581 10.5543 10.1682 10.5543C9.17841 10.5543 8.75366 10.0132 8.75366 10.0132C5.76968 10.5517 5.35146 11.3991 5.29647 14.3385C5.29196 14.5785 5.28987 14.5911 5.28906 14.5632C5.28925 14.6154 5.28947 14.712 5.28947 14.8804C5.28947 14.8804 6.00772 16.3283 10.1682 16.3283C14.3287 16.3283 15.047 14.8804 15.047 14.8804C15.047 14.7722 15.0471 14.697 15.0472 14.6458C15.0464 14.663 15.0448 14.6296 15.0417 14.4365Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8312,
    height: 12.8312,
    fill: "white",
    transform: "translate(3.75391 3.49756)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.de0b69711c6568d41dfbff6beb4ac0ef.svg";
export { ForwardRef as ReactComponent };